export const filterBooks = [
  {
    name: "Mayor monto",
  },
  {
    name: "Menor monto",
  },
];
